export default class QueryHomeController {
	/* @ngInject */
	/**
	 * @param {import('angular').ILocationService} $location
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {any} NodeService
	 */
	constructor($location, $timeout, NodeService) {
		this.$location = $location;
		this.$timeout = $timeout;
		this.NodeService = NodeService;

		/** @type {?import('~/pages/query/query.controller').default} */
		this.ctrl = null;

		/** @type {any} */
		this.tmp = {
			searchQuery: undefined,
		};
	}

	/**
	 * @param {Event} event
	 * @param {import('@knitiv/api-client-javascript').KNode} queryId
	 * @returns {Promise<boolean>} Promise result
	 */
	downloadNodeQuery(event, queryId) {
		return this.NodeService.download(queryId);
	}

	/**
	 * @param {any} row
	 * @returns {*}
	 */
	getName(row) {
		return row[0][0].name;
	}

	/**
	 * @param {any} item
	 */
	openQuery(item) {
		this.$location.search('kid', item.kid);
		this.$timeout(() => {
			this.tmp.searchQuery = undefined;
		});
	}

	$onInit() {
		(async () => this.ctrl?.homeListQueries(this.$location.path() === '/query'))();
	}
}
